export default __webpack_public_path__ + "static/media/Ballroll_00260.183ef94e.png";